// import '../App.css';
// import owner from '../assets/images/owner-smiling.jpeg';
import React, { useEffect, useState } from "react";
import "../App.css";

function MoreAbout() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch("https://family-barbers.com/wp-json/acf/v3/pages/14")
      .then((res) => res.json())
      .then((json) => setData(json.acf))
      .catch((err) => console.error("Error fetching ACF data:", err));
  }, []);

  if (!data) return null;

  return (
    <div id="more-about" className="section">
      <div className="underline more-about-underline"></div>

      <h1>{data.more_about_title}</h1>

      <div className="more-about-container">
        <div className="more-about-child-container-1">
          <h2>{data.more_about_subtitle}</h2>
          <p>{data.more_about_text || "No content added yet."}</p>
        </div>

        <div className="more-about-child-container-2">
          {data.more_about_image && (
            <img
              src={data.more_about_image.url}
              alt={data.more_about_image.alt || "About us image"}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default MoreAbout;

